// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3V2Qa","vLegacy":"SelectSecondary_vLegacy__3GFWC","error":"SelectSecondary_error__wXDau","disabled":"SelectSecondary_disabled__AnJee"};